import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d188f08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "number-spinner" }
const _hoisted_2 = ["disabled", "aria-label"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-minus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["value", "name", "id", "min", "max", "disabled", "required"]
const _hoisted_6 = ["disabled", "aria-label"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-plus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decrease && _ctx.decrease(...args))),
      class: _normalizeClass(_ctx.buttonClass),
      disabled: _ctx.disabledMin,
      "aria-label": _ctx.ariaLabelDecrease
    }, _hoisted_4, 10, _hoisted_2),
    _createElementVNode("input", {
      type: "number",
      value: _ctx.numericValue,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inputValue && _ctx.inputValue(...args))),
      class: _normalizeClass(_ctx.inputClass),
      name: _ctx.inputName,
      id: _ctx.inputId,
      min: _ctx.min,
      max: _ctx.max,
      disabled: _ctx.disabled,
      required: _ctx.required,
      readonly: true
    }, null, 42, _hoisted_5),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.increase && _ctx.increase(...args))),
      class: _normalizeClass(_ctx.buttonClass),
      disabled: _ctx.disabledMax,
      "aria-label": _ctx.ariaLabelIncrease
    }, _hoisted_8, 10, _hoisted_6)
  ]))
}